import { useMemo } from 'react';

import { getFilterOptions } from '../../helpers/filter';

export const useFilterOptions = data => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        breedingStatuses: [],
        breeds: [],
        sex: [],
        types: []
      };
    }

    return {
      breedingStatuses: getFilterOptions(data, 'breeding_status_name'),
      breeds: getFilterOptions(data, 'breed'),
      sex: getFilterOptions(data, 'sex'),
      types: getFilterOptions(data, 'breeding_event_name')
    };
  }, [data]);
};
